(function () {
  var SLIDER_SELECTOR = '[data-custom-slider]';
  var instances = {};

  function getGap(root, name, fallback) {
    var value = parseInt(root.getAttribute(name), 10);

    return isNaN(value) ? fallback : value;
  }

  function getSliderConfig(root) {
    var container = root.querySelector('[data-custom-slider-container]');

    if (!container) {
      return null;
    }

    var pagination = root.querySelector('[data-custom-slider-pagination]');
    var prev = root.querySelector('[data-custom-slider-prev]');
    var next = root.querySelector('[data-custom-slider-next]');

    var options = {
      slidesPerView: 'auto',
      slidesPerGroupAuto: true,
      spaceBetween: getGap(root, 'data-custom-slider-gap-mobile', 16),
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        768: {
          spaceBetween: getGap(root, 'data-custom-slider-gap-desktop', 20)
        }
      }
    };

    if (pagination) {
      options.pagination = {
        el: pagination,
        type: 'bullets',
        clickable: true,
        bulletElement: 'button'
      };
    }

    if (prev && next) {
      options.navigation = {
        prevEl: prev,
        nextEl: next
      };
    }

    return {
      container: container,
      options: options
    };
  }

  function init(root) {
    if (!root || root.dataset.customSliderInitialized === 'true') {
      return;
    }

    var config = getSliderConfig(root);

    if (!config) {
      return;
    }

    var Swiper = window.themeCore && window.themeCore.utils && window.themeCore.utils.Swiper;

    if (!Swiper) {
      return;
    }

    root.dataset.customSliderInitialized = 'true';

    var slider = new Swiper(config.container, config.options);
    var sectionId = root.dataset.sectionId;

    if (sectionId) {
      instances[sectionId] = instances[sectionId] || [];
      instances[sectionId].push(slider);
    }
  }

  function destroy(sectionId) {
    var sliders = instances[sectionId];

    if (!sliders) {
      return;
    }

    sliders.forEach(function (slider) {
      if (slider && typeof slider.destroy === 'function') {
        slider.destroy(true, true);
      }
    });

    delete instances[sectionId];
  }

  function initAll(context) {
    var root = context || document;
    var sliders = root.querySelectorAll ? root.querySelectorAll(SLIDER_SELECTOR) : [];

    Array.prototype.forEach.call(sliders, init);
  }

  function start() {
    initAll();

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroy(event.detail && event.detail.sectionId);
    });
  }

  if (window.themeCore && window.themeCore.loaded) {
    start();
  } else {
    document.addEventListener('theme:all:loaded', start, { once: true });
  }
})();
